import classNames from 'classnames';
import { memo, useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Tab from 'react-bootstrap/Tab';
import { Spinner } from '../../../../../components/Spinner';
import LazyTabPanel from '../../../../../components/LazyTabPanel';
// sub-tabs
import ConsumerGeneralInfoSubTab from '../sub-tabs/payroll/ConsumerGeneralInfoSubTab';
import ConsumerAllCyclesSubTab from '../sub-tabs/payroll/ConsumerAllCyclesSubTab';
import ConsumerPaydaySubTab from '../sub-tabs/payroll/ConsumerPaydaySubTab';

const PAYROL_SUB_TABS = {
  general_info: 'General Info',
  all_cycles: 'All Cycles',
  payday_distribution: 'Payday Distribution',
};

function ConsumerPayrollTab({
  consumer,
  getConsumer,
  profileJson,
  getProfileJson,
  refreshTab,
  setRefreshTab,
}) {
  const [activeSubTab, setActiveSubTab] = useState('general_info');

  const [spinner, setSpinner] = useState(false);

  const toggleActiveSubTab = tab => {
    if (activeSubTab !== tab) {
      setActiveSubTab(tab);
    }
  };

  const getPayroll = async () => {
    setSpinner(true);
    await getProfileJson(consumer?.id);
    setSpinner(false);
  };

  useEffect(() => {
    if (refreshTab === 'payroll') {
      getPayroll();
      setRefreshTab('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshTab]);

  return (
    <div className="h-100 w-100 d-flex flex-column">
      <Spinner
        visible={spinner}
        wrapperStyle={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}
      >
        <Tab.Container activeKey={activeSubTab}>
          <div className="p-3 d-flex align-items-center gap-5 border-bottom">
            {Object.entries(PAYROL_SUB_TABS).map(([key, value]) => (
              <Button
                key={key}
                className={`bo-common-sub-link ${classNames({
                  'bo-common-sub-link-active': activeSubTab === key,
                })}`}
                onClick={() => toggleActiveSubTab(key)}
              >
                {value}
              </Button>
            ))}
          </div>
          <Tab.Content className="d-flex flex-column flex-grow-1">
            <LazyTabPanel activeTab={activeSubTab} tabId="general_info">
              <ConsumerGeneralInfoSubTab
                consumerId={consumer.id}
                consumerPayrollStatus={consumer.payrollStatus}
                consumerLockPayrollDay={consumer.lockPayrollDay}
                consumerPayrollFrequency={consumer.payrollFrequency}
                consumerPayrollDay1={consumer.payrollDay1}
                consumerPayrollDay2={consumer.payrollDay2}
                getConsumer={getConsumer}
                profileJson={profileJson}
                getProfileJson={getProfileJson}
                setSpinner={setSpinner}
              />
            </LazyTabPanel>
            <LazyTabPanel activeTab={activeSubTab} tabId="all_cycles">
              <ConsumerAllCyclesSubTab profileJson={profileJson} />
            </LazyTabPanel>
            <LazyTabPanel activeTab={activeSubTab} tabId="payday_distribution">
              <ConsumerPaydaySubTab profileJson={profileJson} />
            </LazyTabPanel>
          </Tab.Content>
        </Tab.Container>
      </Spinner>
    </div>
  );
}

export default memo(ConsumerPayrollTab);
